var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBack = function SvgIconBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0064A3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.655 13.336l10.62 10.82c.699.713.696 1.856-.007 2.565-.702.708-1.843.717-2.556.02L1.856 16.134c-.78-.763-.795-2.014-.032-2.796l.016-.016c.774-.773 2.028-.773 2.802 0l.013.014z",
    transform: "rotate(90 15 15.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.09 13.456L12.834 24.242c-.666.7-.67 1.797-.01 2.502.633.675 1.692.71 2.367.077l.033-.032 10.653-10.547c.781-.773.787-2.033.014-2.814l-.007-.007c-.762-.762-1.997-.762-2.758 0l-.034.035z",
    transform: "rotate(90 15 15.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 2.001l.002 20c0 1.105.896 2 2 2 1.105 0 2-.895 2-2l-.002-20c0-1.104-.896-2-2-2-1.105 0-2 .896-2 2z",
    transform: "rotate(90 15 15.5)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-back.4b968d3f.svg";
export { ForwardRef as ReactComponent };